import { colorToString } from '../components/widgets/widget.helper';
import get from 'lodash/get';


//BoxShadow
export function getBoxShadow(value) {
    if (!value) {
      return null;
    }
    var styles = {};

    var shadowColor = colorToString( get(value, 'color', {r: 255, g: 255, b: 255, a: 1}));
    var xValue = get(value, 'axes.x', 0);
    var yValue = get(value, 'axes.y', 0);
    var bValue = get(value, 'axes.b', 0);
    var showShadow = get(value, 'show', false);

    if(!showShadow) {
     return null;
    }
    var boxShadow = `${xValue}px ${yValue}px ${bValue}px ${shadowColor}`
    styles['boxShadow'] = boxShadow

    return styles;
  }


//DropShadow
export function getDropShadow(value) {

  if (!value) {
    return null;
  }

  var shadowColor = colorToString( get(value, 'color', {r: 255, g: 255, b: 255, a: 1}));
  var xValue = get(value, 'axes.x', 0);
  var yValue = get(value, 'axes.y', 0);
  var bValue = get(value, 'axes.b', 0);
  var showShadow = get(value, 'show', false);

  if(!showShadow) {
    return null;
  }

  var shadow = {
    "filter": `drop-shadow(${xValue}px ${yValue}px ${bValue}px ${shadowColor})`,
    "WebkitFilter": `drop-shadow(${xValue}px ${yValue}px ${bValue}px ${shadowColor})`
  };

  const isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
  if (isSafari) {
    shadow = {
      ...shadow,
      "willChange": "filter"
    }
  }

  return shadow;
}
